import { Bell, ChevronRight, Mail, UserCircle, UserPlus } from "lucide-react";
import NotificationListItemContent from "./NotificationListItemContent";
import { getNotificationVisualKind } from "../lib/notificationListDisplay";

export const NOTIFICATION_VISUAL_ICONS = {
  application: Mail,
  invites: UserPlus,
  profile: UserCircle,
  default: Bell,
};

/**
 * Shared icon + copy (+ optional chevron) for notification rows.
 * @param {{
 *   notification: object,
 *   accent: "p1" | "p2",
 *   showKicker?: boolean,
 *   showChevron?: boolean,
 *   showRelativeTime?: boolean,
 *   relativeTime?: string,
 * }} props
 */
export default function NotificationListRowVisual({
  notification,
  accent,
  showKicker = true,
  showChevron = false,
  showRelativeTime = false,
  relativeTime = "",
}) {
  const kind = getNotificationVisualKind(notification);
  const Icon = NOTIFICATION_VISUAL_ICONS[kind] || NOTIFICATION_VISUAL_ICONS.default;

  return (
    <>
      <span
        className={`jw-notification-item__icon jw-notification-item__icon--${accent} jw-notification-item__icon--kind-${kind}`}
      >
        <Icon className="jw-notification-item__icon-svg" aria-hidden />
      </span>
      <span className="jw-notification-item__main">
        <NotificationListItemContent notification={notification} showKicker={showKicker} />
        {showRelativeTime && relativeTime ? (
          <time className="jw-notification-item__time" dateTime={notification.createdAt}>
            {relativeTime}
          </time>
        ) : null}
      </span>
      {showChevron ? <ChevronRight className="jw-notification-item__chevron" aria-hidden /> : null}
    </>
  );
}
